import { Icon } from '@creditsights/styleguide-web';
import { ReactElement, useEffect, useState } from 'react';
import './Validator.scss';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function Validator({ regex, value = '', message, icon }): ReactElement {
  const [valid, setValid] = useState(false);

  useEffect(() => {
    setValid(regex.test(value));
  }, [regex, value]);

  return (
    <div className={`cs-validator-ctx ${valid ? 'valid' : 'invalid'}`}>
      <Icon name={icon} height={12} width={12} />
      <div className="message">{message}</div>
    </div>
  );
}

export default Validator;
